import axios from 'axios'
import lstModules from 'common/json/lstModules.json'
var tokenid = localStorage.getItem('tokenid')
var httpURL = lstModules['ptm'].url + ':' + lstModules['ptm'].port
var httpURLCommon = lstModules['main'].url + ':' + lstModules['main'].port
var httpURLTT = lstModules['timeTable'].url + ':' + lstModules['timeTable'].port

function getClassListSvc(callback1) {
    var status = 'Success'
    var obj = { status: status }
    axios({
        url: httpURLCommon + '/sms/mst/cls/list',
        method: 'POST',
        params: {},
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = response.data.SvcMsg
                obj.status = 'Success'
                obj.lstCls = response.data.lstClass
                callback1(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                callback1(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            callback1(obj)
        })
}

function getSectionData(clsId, callback2) {
    var status = 'Success'
    var obj = { status: status, clsId: clsId }
    axios({
        url: httpURLTT + '/sms/tt/v1/tt/section/list',
        // url: httpURLCommon + '/sms/cls/sec/list',
        method: 'POST',
        params: { clsId },
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = ''
                obj.status = 'Success'
                obj.lstSection = response.data.lstSection
                callback2(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                callback2(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            callback2(obj)
        })
}
function slideShowPtm(ptmId, sectionId, cb) {
    var status = 'Success'
    var obj = { status: status, message: '' }
    axios({
        url: httpURL + '/sms/ptm_play/dtls',
        method: 'POST',
        params: { ptmId: ptmId, sectionId: sectionId },
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = ''
                obj.status = 'Success'
                obj.objWelcome = response.data.objWelcome
                obj.lstTopper = response.data.lstTopper
                obj.lstSubTchRoom = response.data.lstSubTchRoom
                obj.lstAchievement = response.data.lstAchievement
                obj.lstGallery = response.data.lstGallery
                obj.basePathPtmToppers = response.data.basePathPtmToppers;
                obj.basePathPtmGallery = response.data.basePathPtmGallery;
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })

}

function viewPhotoSvc(userId, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", httpURL + '/sms/system/staff/photo/view?userId=' + userId, true);
    xhr.setRequestHeader('tokenid', tokenid);
    xhr.responseType = "arraybuffer";
    xhr.onload = function (e) {
        // console.log(xhr)
        var arrayBufferView = new Uint8Array(this.response);
        var blob = new Blob([arrayBufferView], { type: "image/jpeg" });
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(blob);
        // console.log(blob)
        callback(imageUrl, xhr.response);
    };
    xhr.send();
}
const getPtmPlanSettingSvc = (ptmId, cb) => {
    var status = 'Success'
    var obj = { status: status, message: '' }
    axios({
        url: httpURL + '/sms/ptm/setting/list',
        method: 'POST',
        params: { ptmId: ptmId },
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = ''
                obj.status = 'Success'
                obj.lstPtmSetting = response.data.lstPtmSetting
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })
}

export {
    getClassListSvc, getSectionData, slideShowPtm, viewPhotoSvc, getPtmPlanSettingSvc
}
